import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4dbf3f04&scoped=true&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"
import style0 from "./List.vue?vue&type=style&index=0&id=4dbf3f04&lang=less&scoped=true&"
import style1 from "./List.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf3f04",
  null
  
)

export default component.exports